import {
  Avatar, ListManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterCastrations from '../../components/FilterCastrations'

function CastrationsByBilling({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.castrationsByBilling,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Castrações por faturamento"
        subtitle="Quantidade de castrações realizadas, não faturadas, concluídas e aguardando faturar"
        icon="fas fa-chart-bar"
        rightAction={() => <FilterCastrations />}
      />
      <ListManager
        count={data?.clinics?.length || 0}
        loading={loading}
        error={error}
      >
        {Boolean(data) && (
          <>
            <div className="p-2 bg-gray s-rounded">
              <div className="text-small">
                <b>Quantidade faturada: </b>
                <span>quantidade de castrações em lotes aprovados</span>
              </div>
              <div className="text-small">
                <b>Quantidade não faturada: </b>
                <span>quantidade de castrações que não possuem lote</span>
              </div>
              <div className="text-small">
                <b>Quantidade aguardando faturar: </b>
                <span>
                  quantidade de castrações em lotes que estão aguardando
                </span>
              </div>
            </div>

            <table className="table table-hover text-small">
              <thead>
                <tr>
                  <th>Clínica</th>
                  <th className="text-right" width="300px">
                    Qtd. Faturada
                  </th>
                  <th className="text-right" width="300px">
                    Qtd. Não Faturada
                  </th>
                  <th className="text-right" width="300px">
                    Qtd. Aguardando faturar
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.clinics.map((row) => (
                  <tr key={row?.id}>
                    <td>
                      <Avatar
                        avatarSize="sm"
                        name={row?.fullName}
                        photoURL={row?.photoURL}
                        alt="Imagem de usuário"
                      />
                      &nbsp;{row?.fullName}
                    </td>
                    <td className="text-right">{row?.billed}</td>
                    <td className="text-right">{row?.notBilled}</td>
                    <td className="text-right">{row?.awaiting}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th>Totais:</th>
                  <th className="text-right">{data?.totals?.billed}</th>
                  <th className="text-right">{data?.totals?.notBilled}</th>
                  <th className="text-right">{data?.totals?.awaiting}</th>
                </tr>
              </tfoot>
            </table>
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default CastrationsByBilling
